module.exports = __webpack_public_path__ + "static/img/ticket_on.1f9f5778.svg";